var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'is-invalid': _setup.hasErrors,
      'd-flex align-items-baseline': _vm.inline
    }
  }, [_c('div', {
    class: {
      'pr-2 mb-0 flex-shrink-0': _vm.inline
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm.label ? _c('label', {
    class: [{
      'text-danger': _setup.hasErrors,
      'small': _vm.size === 'sm',
      'mb-0': _vm.secondaryText
    }, _vm.labelClasses, 'flex-fill'],
    attrs: {
      "for": _vm.name
    }
  }, [_c('DisplayText', {
    attrs: {
      "text": _vm.label
    }
  }), !_setup.containsHTML(_vm.label) ? _c('span', [_vm._v(_vm._s(_vm.required ? '*' : ''))]) : _vm._e()], 1) : _vm._e(), _vm._t("label-append")], 2), _vm.secondaryText ? _c('small', {
    staticClass: "form-group-note form-text text-muted d-block mb-2",
    class: _vm.noteClasses
  }, [_c('DisplayText', {
    attrs: {
      "text": _vm.secondaryText
    }
  })], 1) : _vm._e()]), _vm._t("default"), _setup.hasErrors ? _c(_setup.BaseErrorMessage, {
    attrs: {
      "errors": _vm.errors
    }
  }) : _vm.note ? _c('small', {
    staticClass: "form-group-note form-text text-muted d-block",
    class: _vm.noteClasses
  }, [_c('DisplayText', {
    attrs: {
      "text": _vm.note
    }
  })], 1) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };